import { render, staticRenderFns } from "./SchoolTeacherModal.vue?vue&type=template&id=587118cb&"
import script from "./SchoolTeacherModal.vue?vue&type=script&lang=js&"
export * from "./SchoolTeacherModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports